// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import arrearCollectionActionTypes from './arrear-Collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// GET ARREAR MEMBER LOAN INFO RESPONSE
	getArrearMemberLoanInfoResponse: null,
	getArrearMemberLoanInfoArr: [],

	// UPDATED ARREAR COLLECTION APPROVE RESPONSE
	updatedArrearCollectionApproveResponse: null,

	// UPDATE COMMON LOAN PAID DETAILS RESPONSE
	updateCommonLoanPaidDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  MEMBER LOAN LIST DETAILS START  ******************** */
		case arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_SUCCESS:
			return {
				...state,
				getArrearMemberLoanInfoResponse: action.payload,
				getArrearMemberLoanInfoArr: docodeHexResponse(
					action.payload,
					'FetchArrearMemberListKey',
				),
			};

		case arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_FAILURE:
			return { ...state, getArrearMemberLoanInfoResponse: action.payload };

		case arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, getArrearMemberLoanInfoResponse: null };

		/** *********************  MEMBER LOAN LIST DETAILS START  ******************** */

		/** ***************** UPDATE ARREAR COLLECTION APPROVE START *********************** */

		case arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_SUCCESS:
			return {
				...state,
				updatedArrearCollectionApproveResponse: action.payload,
			};

		case arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_FAILURE:
			return { ...state, updatedArrearCollectionApproveResponse: action.payload };

		case arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_CHANGED:
			return { ...state, updatedArrearCollectionApproveResponse: null };
		/** ***************** UPDATE ARREAR COLLECTION APPROVE START *********************** */

		/** ***************** UPDATE COMMON LOAN PAID DETAILS START *********************** */
		case arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_SUCCESS:
			return {
				...state,
				updateCommonLoanPaidDetailsResponse: action.payload,
			};

		case arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_FAILURE:
			return { ...state, updateCommonLoanPaidDetailsResponse: action.payload };

		case arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateCommonLoanPaidDetailsResponse: null };
		/** ***************** UPDATE COMMON LOAN PAID DETAILS END *********************** */
		default:
			return state;
	}
};
